var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarrantyAfterSalesSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9776030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance Offer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.4136 6.93512C44.4136 6.82042 44.3778 6.70857 44.3112 6.61521C44.2445 6.52185 44.1504 6.45163 44.0419 6.41437C40.1645 5.08994 36.0974 4.40511 32 4.38672C27.9026 4.40511 23.8355 5.08994 19.9581 6.41437C19.8496 6.45163 19.7555 6.52185 19.6888 6.61521C19.6222 6.70857 19.5864 6.82042 19.5864 6.93512C19.556 11.5406 18.8546 24.4633 27.4544 30.6114C28.7936 31.6187 30.2445 32.4681 31.7783 33.1428C31.9203 33.2014 32.0797 33.2014 32.2217 33.1428C33.7556 32.4681 35.2065 31.6187 36.5456 30.6114C45.1454 24.4633 44.444 11.5406 44.4136 6.93512ZM37.6006 13.4391L31.0996 21.0915C30.9764 21.2382 30.8228 21.3565 30.6493 21.4379C30.4759 21.5194 30.2868 21.5621 30.0952 21.5631H30.0923C29.9008 21.5625 29.7118 21.5203 29.5382 21.4393C29.3647 21.3584 29.2109 21.2407 29.0874 21.0944L26.4018 17.9547C26.3164 17.855 26.2515 17.7393 26.2108 17.6145C26.17 17.4896 26.1543 17.3579 26.1645 17.227C26.1746 17.096 26.2105 16.9684 26.27 16.8513C26.3295 16.7342 26.4114 16.63 26.5112 16.5446C26.7127 16.3721 26.9745 16.2867 27.239 16.3072C27.3699 16.3174 27.4976 16.3532 27.6147 16.4127C27.7318 16.4722 27.836 16.5542 27.9214 16.6539L30.0903 19.1901L36.0762 12.1442C36.2479 11.942 36.4929 11.8164 36.7572 11.7949C37.0216 11.7733 37.2837 11.8577 37.4858 12.0294C37.688 12.2012 37.8136 12.4461 37.8352 12.7105C37.8567 12.9749 37.7723 13.237 37.6006 13.4391Z",
    fill: "url(#paint0_linear_29_23146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.25 54.4706V58.7564C29.2289 59.0018 29.1123 59.2291 28.9253 59.3894C28.7383 59.5498 28.4958 59.6302 28.25 59.6135H15.75C15.5042 59.6302 15.2617 59.5498 15.0747 59.3894C14.8877 59.2291 14.7711 59.0018 14.75 58.7564V54.4706C14.7711 54.2252 14.8877 53.9979 15.0747 53.8375C15.2617 53.6772 15.5042 53.5968 15.75 53.6135H28.25C28.4958 53.5968 28.7383 53.6772 28.9253 53.8375C29.1123 53.9979 29.2289 54.2252 29.25 54.4706Z",
    fill: "url(#paint1_linear_29_23146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.8216 52.1628H15.9316C15.6264 51.2003 15.4683 51.2943 6.61161 42.6528C5.91559 41.9643 5.46874 41.0636 5.34161 40.0928C4.49751 33.6051 4.67635 27.0251 5.87161 20.5928C5.89413 20.4739 5.94404 20.3618 6.01737 20.2655C6.09071 20.1692 6.18546 20.0912 6.29413 20.0379C6.4028 19.9845 6.52239 19.9572 6.64345 19.958C6.76451 19.9589 6.88371 19.9879 6.99161 20.0428C8.57836 20.7871 9.83117 22.0956 10.5059 23.7131C11.1807 25.3307 11.2291 27.1415 10.6416 28.7928C10.4259 29.4322 10.4472 30.1278 10.7016 30.7528C10.7961 31.2265 10.9299 31.6914 11.1016 32.1428C8.92902 32.608 8.29675 35.5335 10.0116 37.4628L14.9916 43.0828C15.1676 43.2784 15.4136 43.3967 15.6762 43.412C15.9388 43.4273 16.1969 43.3384 16.3944 43.1646C16.5919 42.9908 16.7129 42.7461 16.7311 42.4837C16.7493 42.2212 16.6632 41.9622 16.4916 41.7628L11.5016 36.1328C10.1816 34.6428 11.9016 32.3728 14.2016 34.6528C15.5916 36.0228 17.0416 37.3328 18.4616 38.6728C19.086 39.2975 20.0321 39.1529 20.9516 39.3328C22.5997 39.639 24.1163 40.4374 25.3016 41.6228C28.2956 44.5978 27.8216 48.0763 27.8216 52.1628Z",
    fill: "url(#paint2_linear_29_23146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.75 53.6135H48.25C48.4958 53.5968 48.7383 53.6772 48.9253 53.8375C49.1123 53.9979 49.2289 54.2252 49.25 54.4706V58.7564C49.2289 59.0018 49.1123 59.2291 48.9253 59.3894C48.7383 59.5498 48.4958 59.6302 48.25 59.6135H35.75C35.5042 59.6302 35.2617 59.5498 35.0747 59.3894C34.8877 59.2291 34.7711 59.0018 34.75 58.7564V54.4706C34.7711 54.2252 34.8877 53.9979 35.0747 53.8375C35.2617 53.6772 35.5042 53.5968 35.75 53.6135Z",
    fill: "url(#paint3_linear_29_23146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.6984 41.6228C39.8837 40.4374 41.4003 39.639 43.0484 39.3328C43.9411 39.1581 44.9166 39.2949 45.5384 38.6728C46.9584 37.3328 48.4085 36.0228 49.7984 34.6528C52.0984 32.3728 53.8184 34.6428 52.4984 36.1328L47.5084 41.7628C47.3368 41.9622 47.2508 42.2213 47.269 42.4837C47.2872 42.7461 47.4081 42.9908 47.6056 43.1646C47.8031 43.3384 48.0612 43.4273 48.3238 43.412C48.5865 43.3967 48.8325 43.2784 49.0084 43.0828L53.9884 37.4628C55.7033 35.5335 55.071 32.608 52.8984 32.1428C53.0701 31.6914 53.2039 31.2265 53.2984 30.7528C53.5529 30.1278 53.5742 29.4322 53.3584 28.7928C52.771 27.1415 52.8193 25.3307 53.4941 23.7131C54.1689 22.0956 55.4217 20.7871 57.0084 20.0428C57.1163 19.9879 57.2355 19.9589 57.3566 19.958C57.4776 19.9572 57.5972 19.9845 57.7059 20.0379C57.8146 20.0912 57.9093 20.1692 57.9827 20.2655C58.056 20.3618 58.1059 20.4739 58.1284 20.5928C59.3237 27.0251 59.5025 33.6051 58.6584 40.0928C58.5313 41.0636 58.0844 41.9643 57.3884 42.6528C48.5317 51.2943 48.3736 51.2003 48.0684 52.1628H36.1784C36.1784 48.0763 35.7044 44.5978 38.6984 41.6228Z",
    fill: "url(#paint4_linear_29_23146)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_23146",
    x1: 44.4389,
    y1: -10.0133,
    x2: 19.5611,
    y2: -10.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_23146",
    x1: 29.25,
    y1: 50.6092,
    x2: 14.75,
    y2: 50.6092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_23146",
    x1: 27.849,
    y1: 3.8556,
    x2: 4.81876,
    y2: 3.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_23146",
    x1: 49.25,
    y1: 50.6092,
    x2: 34.75,
    y2: 50.6092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29_23146",
    x1: 59.1813,
    y1: 3.8556,
    x2: 36.151,
    y2: 3.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2327"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyAfterSalesSupport);
export default __webpack_public_path__ + "static/media/warranty-after-sales-support.bd15ae326802e4aab7693047030b2694.svg";
export { ForwardRef as ReactComponent };